
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 1H9a5 5 0 00-5 5v3H1v4h3v8h4v-8h3l1-4H8V6a1 1 0 011-1h3z","fill":"none","stroke":"#e0e0e0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    